/*
 * kokoot — client-side TOC builder for shop policies.
 * Tinker (OS 2.0) ignores templates/policy.liquid for shop policies, so
 * we build the TOC sidebar in the browser AFTER Shopify renders the page.
 *
 * Features:
 *  - Scans h2 elements inside .shopify-policy__container, builds TOC aside
 *  - Wraps content in .kokoot-policy-page grid (CSS handles styling)
 *  - Scrollspy: highlights current section (via .is-active class) while scrolling
 */
(function () {
  'use strict';

  // Only on /policies/* paths
  if (!/^\/policies\//.test(window.location.pathname)) return;

  var HEADER_OFFSET = 120; // sticky announcement bar + header height

  function slugify(text) {
    return (text || '')
      .toLowerCase()
      .replace(/^\d+\.\s*/, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 60) || 'section';
  }

  function setupScrollspy(h2s, tocLinks) {
    if (!h2s.length || !tocLinks.length) return;

    var linkMap = {};
    tocLinks.forEach(function (l) {
      var id = (l.getAttribute('href') || '').slice(1);
      if (id) linkMap[id] = l;
    });

    function updateActive() {
      var activeId = null;
      for (var i = 0; i < h2s.length; i++) {
        var rect = h2s[i].getBoundingClientRect();
        if (rect.top - HEADER_OFFSET <= 0) {
          activeId = h2s[i].id;
        } else {
          break;
        }
      }
      // If scrolled above all h2s, default to first
      if (!activeId && h2s.length > 0) activeId = h2s[0].id;

      Object.keys(linkMap).forEach(function (id) {
        linkMap[id].classList.toggle('is-active', id === activeId);
      });
    }

    var scrollPending = false;
    window.addEventListener('scroll', function () {
      if (scrollPending) return;
      scrollPending = true;
      window.requestAnimationFrame(function () {
        updateActive();
        scrollPending = false;
      });
    }, { passive: true });

    updateActive(); // initial state
  }

  function buildTOC() {
    var container = document.querySelector('.shopify-policy__container');
    if (!container) return;
    if (container.classList.contains('kokoot-policy-active')) return;

    var h2s = Array.prototype.slice.call(container.querySelectorAll('h2'));
    if (h2s.length < 2) return;

    // Ensure each h2 has an id
    var seenIds = {};
    h2s.forEach(function (h2) {
      if (!h2.id) {
        var slug = slugify(h2.textContent);
        if (seenIds[slug]) {
          seenIds[slug]++;
          slug = slug + '-' + seenIds[slug];
        } else {
          seenIds[slug] = 1;
        }
        h2.id = slug;
      }
    });

    // Build TOC aside
    var toc = document.createElement('aside');
    toc.className = 'kokoot-policy-page__toc';

    var tocTitle = document.createElement('p');
    tocTitle.className = 'kokoot-policy-page__toc-title';
    tocTitle.textContent = 'On This Page';
    toc.appendChild(tocTitle);

    var ul = document.createElement('ul');
    h2s.forEach(function (h2) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h2.id;
      a.textContent = (h2.textContent || '').trim();
      li.appendChild(a);
      ul.appendChild(li);
    });
    toc.appendChild(ul);

    // Build grid wrapper
    var wrapper = document.createElement('div');
    wrapper.className = 'kokoot-policy-page';

    var contentWrap = document.createElement('div');
    contentWrap.className = 'kokoot-policy-page__content';

    while (container.firstChild) {
      contentWrap.appendChild(container.firstChild);
    }

    wrapper.appendChild(toc);
    wrapper.appendChild(contentWrap);
    container.appendChild(wrapper);
    container.classList.add('kokoot-policy-active');

    // After DOM is wrapped, h2s are inside contentWrap. Find them again to set up scrollspy.
    var contentH2s = Array.prototype.slice.call(contentWrap.querySelectorAll('h2[id]'));
    var tocLinks = Array.prototype.slice.call(toc.querySelectorAll('a'));
    setupScrollspy(contentH2s, tocLinks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildTOC);
  } else {
    buildTOC();
  }
})();
